module.exports = __webpack_public_path__ + "static/media/Odin.860a5dee.png";